export const updateUrl = (newUrl: string, title: string, state?: any): void => {
	const oldUrl = window.location.href;

	if (oldUrl !== newUrl) {
		window.gtag("set", "page_referrer", oldUrl);

		if (typeof window.history.pushState === "function") {
			window.history.pushState(state, title, newUrl);
		}
	}
};
